import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { FiCheck, FiX } from 'react-icons/fi';

import styles from './styles.module.scss';

interface IProps {
  type: 'success' | 'error';
  text: string;
  description?: string;
  setModal: (value: boolean) => void;
}

export const LoginStatusModal = ({
  text,
  description,
  type,
  setModal,
}: IProps) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    closeButtonRef.current?.focus();

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setModal(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [setModal]);

  return createPortal(
    <div
      className={styles.overlay}
      onClick={() => setModal(false)}
      role="presentation"
    >
      <div
        className={styles.content}
        role="dialog"
        aria-modal="true"
        aria-label={type === 'success' ? 'Sucesso' : 'Erro'}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.icon} data-type={type}>
          {type === 'success' ? <FiCheck size={28} /> : <FiX size={28} />}
        </div>
        <p>{text}</p>
        {description && <p className={styles.description}>{description}</p>}
        <button
          ref={closeButtonRef}
          type="button"
          className={styles.closeButton}
          onClick={() => setModal(false)}
        >
          Fechar
        </button>
      </div>
    </div>,
    document.body
  );
};
